/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import './index.scss';
import EditIcon from './component/EditIcon';
import { saveHighlightList } from '@home/services/studio';
import { useIntl, useParams } from 'umi';
import { notification } from 'tea-component';
import EditModal from './component/EditModal';
import moment from 'moment';

interface IProps {
  className: string;
  style: React.CSSProperties;
  filter: any;
  gameInfo?: any;
  refresh?: any;
  loading: boolean;
  fetchData:()=>void;
  reportData: any;
  // 是否编辑过
  isEdited: boolean;
  editPermission: boolean;
  clickAddHighlight: boolean;
  setClickAddHighlight:()=>void;
}

export default function EditHighlights(props: IProps) {
  const { 
    className, 
    style, 
    filter, 
    gameInfo,
    refresh, 
    loading, 
    reportData, 
    fetchData, 
    isEdited, 
    editPermission, 
    clickAddHighlight, 
    setClickAddHighlight, 
    ...restProps } = props || {};
  const { formatMessage } = useIntl();
  const [showModal, setShowModal] = useState(false);
  const { studioId } = useParams() || {} as any;
  const { date_type: dateType, start_time: startTime, end_time: endTime } = filter || {};

  // 确认按钮点击事件，编辑gpt 数据
  const handleSubmit = (data: string) => {
    const params = {
      studio_code: studioId,
      unified_id: gameInfo?.edition_unified_id,
      period: dateType,
      start_date: moment(startTime).format('YYYY-MM-DD'),
      end_date: moment(endTime).format('YYYY-MM-DD'),
      highlights: data
    };
  
    return saveHighlightList?.(params)
      .then(() => {
        notification.success({
          description: formatMessage({ id: 'dbh_studio_funcom_save_modal_highlights_success' }),
          duration: 1000,
        });
        setShowModal(false);
        fetchData();
      })
      .catch(() => {
        notification.error({
          description: formatMessage({ id: 'dbh_studio_funcom_save_modal_highlights_failed' }),
          duration: 1000,
        });
        setShowModal(true);
      });

  };  

  const changeShowModal = () => {
    setShowModal(!showModal);
  };

  useEffect(()=>{
    if(clickAddHighlight){
      setShowModal(true);
    }
  },[clickAddHighlight]);

  return (
    <div className={className} style={style}>
      {(!loading && editPermission) && <EditIcon onClick={changeShowModal} showModal={showModal}/>}
      <EditModal
        reportData={reportData}
        closeModal={changeShowModal}
        isVisible={showModal}
        handleSubmit={handleSubmit}
        handleCancel={showModal}
        handelCancel={changeShowModal}
        setClickAddHighlight={setClickAddHighlight}
        clickAddHighlight={clickAddHighlight}
        // 解决重新打开modal编辑器报错问题，editor未实例化
        destroyOnClose={false}
        {...restProps}
      />
    </div>

  );
}
